import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { AuthenticationService } from './authentication.service';

export class Interceptor implements HttpInterceptor {

	constructor(private _authenticationService: AuthenticationService) {
	}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		if (req.url.includes('CXTWCF')) {
			const user = JSON.parse(localStorage.getItem('Rapidship:user'));
			if (user && user.token) {
				req = req.clone({setHeaders: {Authorization: `Token ${user.token}`}});
			}
			if (!req.headers.has('Content-Type')) {
				req = req.clone({setHeaders: {'Content-Type': 'application/json'}});
			}
			req = req.clone({setHeaders: {Accept: 'application/json'}});
			req = req.clone({setHeaders: {CallingApplication: 'Rapidship'}});
		}

		return next.handle(req).pipe(tap((event: HttpEvent<any>) => {
				if (event instanceof HttpResponse) {
					if (event.status === 200 && event.url.includes(localStorage.getItem('Rapidship:apiUrl'))) {
						const twentyMinutesLater = new Date();
						twentyMinutesLater.setMinutes(twentyMinutesLater.getMinutes() + 20);
						this._authenticationService.expirationOfSession = twentyMinutesLater; // set 20 minute sessionTimeout
					}
				}
			}), catchError((error: any) => {
				error.body = req.body; // This is to add the request body to the error response
				// Need to logout the user if error message includes CXT Software requires a valid license
				if (error.status === 401 || error?.error?.detailedMsg?.includes('CXT Software requires a valid license') && !error?.url?.includes('AnonymousOptions')) {
					this._authenticationService.showAuthModal(error);
					return of(null);
				} else {
					return throwError(error);
				}
			})
		);

	}
}
